module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-wrong-ans.9dbb6613.svg";